import { InjectionToken } from '@angular/core';
import { PageMeta } from './models/page-meta';

export const TOKEN_PAGE_META_DEFAULT = new InjectionToken<Required<PageMeta>>('tokenPageMetaDefault');
